import * as consts from '../constants';

export const getOrderStatusText = (status: number, t: any) => {
  switch (status) {
    case consts.orderStatus.INIT:
      return t("unreviewed");
    case consts.orderStatus.REVIEWED:
      return t("reviewed");
    case consts.orderStatus.CONFIRMED:
        return t("confirmed");
    case consts.orderStatus.ASSIGNED:
      return t("assigned");
    case consts.orderStatus.COMPLETED:
      return t("completed");
    case consts.orderStatus.CANCELED:
      return t("canceled");
    default:
      return t("unknown");
  }
};

export const getServiceTypeText = (serviceType: number | undefined, t: any) => {
  switch (serviceType) {
    case consts.serviceType.AIRPORT_PICK_UP:
      return t("selectPickup");
    case consts.serviceType.AIRPORT_DROP_OFF:
      return t("selectDropoff");
    case consts.serviceType.CHARTER:
      return t("selectAroundCity");
    default:
      return t("others");
  }
};